import { render, staticRenderFns } from "./BuyersInformation.vue?vue&type=template&id=b3c99e5e&scoped=true&"
import script from "./BuyersInformation.vue?vue&type=script&lang=ts&"
export * from "./BuyersInformation.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersInformation.vue?vue&type=style&index=0&id=b3c99e5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c99e5e",
  null
  
)

export default component.exports